import * as actionTypes from './actionTypes';

export const addDatumPlukbeplan = () => {
    return {
        type: actionTypes.PLUKBEPL_ADD_DATUM
    };
};

export const subtractDatumPlukbeplan = () => {
    return {
        type: actionTypes.PLUKBEPL_SUBTRACT_DATUM
    };
};

export const setVandagDatumPlukbeplan = () => {
    return {
        type: actionTypes.PLUKBEPL_SET_VANDAG
    };
};

export const setDatumPlukbeplan = (datum) => {
    return {
        type: actionTypes.PLUKBEPL_SET_DATUM,
        datum: datum
    };
};

export const setWeekBeginPlukbeplan = (dag, id) => {
    return {
        type: actionTypes.PLUKBEPL_SET_WEEK_BEGIN,
        dag: dag,
        id: id
    };
};

export const getPlukbeplanKultivars = (seisoen) => {
    return {
        type: actionTypes.GET_PLUKBEPL_KULTIVARS,
        seisoen: seisoen
    };
};

export const setPlukbeplanKultivars = (kultivars) => {
    return {
        type: actionTypes.SET_PLUKBEPL_KULTIVARS,
        kultivars: kultivars
    };
};

export const setPlukbeplanKultivarsFailed = ({ error, easymessage, status, message }) => {
    return {
        type: actionTypes.SET_PLUKBEPL_KULTIVARS_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const getPlukbeplanWeek = (jaar, week) => {
    return {
        type: actionTypes.GET_PLUKBEPL_WEEK,
        jaar: jaar,
        week: week
    };
};

export const setPlukbeplanWeek = (week, dae, items) => {
    return {
        type: actionTypes.SET_PLUKBEPL_WEEK,
        week: week,
        dae: dae,
        items: items
    };
};

export const setPlukbeplanWeekFailed = ({ error, easymessage, status, message }) => {
    return {
        type: actionTypes.SET_PLUKBEPL_WEEK_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const getPlukbeplanWeekDae = (jaar, week) => {
    return {
        type: actionTypes.GET_PLUKBEPL_WEEKDAE,
        jaar: jaar,
        week: week
    };
};

export const setPlukbeplanWeekDae = (data) => {
    return {
        type: actionTypes.SET_PLUKBEPL_WEEKDAE,
        data: data
    };
};

export const setPlukbeplanWeekDaeFailed = ({ error, easymessage, status, message }) => {
    return {
        type: actionTypes.SET_PLUKBEPL_WEEKDAE_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const getPlukbeplanOpstellings = () => {
    return {
        type: actionTypes.GET_PLUKBEPL_OPSTELLINGS
    };
};

export const setPlukbeplanOpstellings = (data) => {
    return {
        type: actionTypes.SET_PLUKBEPL_OPSTELLINGS,
        data: data
    };
};

export const setPlukbeplanOpstellingsFailed = (error) => {
    return {
        type: actionTypes.SET_PLUKBEPL_OPSTELLINGS_FAILED,
        error: error.error,
        easymessage: error.easymessage,
        status: error.status,
        message: error.message
    };
};

export const setPlukbeplanOpstellingsSnackbarSuccess = () => {
    return {
        type: actionTypes.SET_PLUKBEPL_OPSTELLINGS_SNACKBAR_SUCCESS
    };
};

export const setPlukbeplanOpstellingsSnackbarFailed = (error) => {
    return {
        type: actionTypes.SET_PLUKBEPL_OPSTELLINGS_SNACKBAR_FAILED,
        error: error.error,
        easymessage: error.easymessage,
        status: error.status,
        message: error.message
    };
};

export const setSnackbarClose = () => {
    return {
        type: actionTypes.SET_PLUKBEPL_SNACKBAR_CLOSE
    };
};

export const setViewEenheidPlukbeplan = (eenheid, id) => {
    return {
        type: actionTypes.PLUKBEPL_SET_VIEWEENHEID,
        eenheid: eenheid,
        id: id
    };
};

export const getPlukbeplanWeekTeiken = (jaar, week, kultivar) => {
    return {
        type: actionTypes.PLUKBEPL_GET_WEEKTEIKEN,
        jaar: jaar,
        week: week,
        kultivar: kultivar
    };
};

export const setPlukbeplanWeekTeiken = (kultivar, week, data) => {
    return {
        type: actionTypes.PLUKBEPL_SET_WEEKTEIKEN,
        kultivar: kultivar,
        week: week,
        data: data
    };
};

export const getPlukbeplanDagTeiken = (jaar, week, dag, kultivar) => {
    return {
        type: actionTypes.PLUKBEPL_GET_DAGTEIKEN,
        jaar: jaar,
        week: week,
        dag: dag,
        kultivar: kultivar
    };
};

export const setPlukbeplanDagTeiken = (kultivar, week, dag, data) => {
    return {
        type: actionTypes.PLUKBEPL_SET_DAGTEIKEN,
        kultivar: kultivar,
        week: week,
        dag: dag,
        data: data
    };
};

export const getPlukbeplanDagItem = (jaar, week, dag, kultivar, id) => {
    return {
        type: actionTypes.PLUKBEPL_GET_DAGITEM,
        jaar: jaar,
        week: week,
        dag: dag,
        kultivar: kultivar,
        id: id
    };
};

export const setPlukbeplanDagItem = (kultivar, week, dag, data) => {
    return {
        type: actionTypes.PLUKBEPL_SET_DAGITEM,
        kultivar: kultivar,
        week: week,
        dag: dag,
        data: data
    };
};

export const setGewasFilter = (gewas) => {
    return {
        type: actionTypes.PLUKBEPL_SET_GEWASFILTER,
        gewas: gewas
    };
};